// * Bootstrap libraries
import './_bootstrap';

// * Any other global site-wide JavaScript should be placed below.

document.addEventListener('DOMContentLoaded', function() {
    (function () {
        'use strict';

        var tasks = [
            { formula: 'Селести ПДРН', img: 'sites/default/files/page_images/pdrn-vial-v2.webp', pattern: 'sites/default/files/page_images/pattern-pdrn.svg', patternSize: '660px auto', patternOpacity: 0.94, patternFilter: 'saturate(1.45) contrast(1.06) brightness(0.98)', alt: 'Селести ПДРН', accent: '#E83E72' },
            { formula: 'Селести Трегалоза', img: 'sites/default/files/page_images/trehaloza-vial-v2.webp', pattern: 'sites/default/files/page_images/pattern-trehalose-v2.svg', patternSize: '660px auto', patternOpacity: 0.86, patternFilter: 'none', alt: 'Селести Трегалоза', accent: '#3F9FD3' },
            { formula: 'Селести Матриксил', img: 'sites/default/files/page_images/matriksil-vial-v2.webp', pattern: 'sites/default/files/page_images/pattern-matrixyl.svg', patternSize: '660px auto', patternOpacity: 0.78, patternFilter: 'none', alt: 'Селести Матриксил', accent: '#B82D49' },
            { formula: 'Селести Янтарная', img: 'sites/default/files/page_images/yantarnaya-vial-v2.webp', pattern: 'sites/default/files/page_images/pattern-succinic-v2.svg', patternSize: '660px auto', patternOpacity: 0.82, patternFilter: 'none', alt: 'Селести Янтарная', accent: '#A9791E' }
        ];

        var requestContent = {
            price: { title: 'Получить прайс и условия', description: 'Оставьте контакты — менеджер отправит прайс, протоколы и информацию по условиям работы.', button: 'Получить прайс и условия', label: 'Прайс и условия сотрудничества' },
            protocols: { title: 'Протоколы применения', description: 'Оставьте контакты — менеджер направит протоколы по формулам Селести.', button: 'Получить протоколы', label: 'Протоколы применения' },
            documents: { title: 'Комплект документов', description: 'Оставьте контакты — менеджер направит регистрационные документы по линейке.', button: 'Получить документы', label: 'Регистрационные документы' }
        };

        var legalContent = {
            privacy: {
                title: 'Политика обработки персональных данных',
                sections: [
                    { heading: '1. Оператор персональных данных', body: 'Оператором персональных данных является ООО «Клинрум Девелопмент».\nЮридический адрес: 109544, г. Москва, ул. Рабочая, д. 93, стр. 2\nОГРН: 1167746375587\nИНН: 7713414230\nКПП: 770901001\nТелефон: +7 (495) 646-01-93\nE-mail оператора: crd2016@yandex.ru\nE-mail сайта: info@selesti.ru\nГенеральный директор: Ильин Станислав Валерьевич' },
                    { heading: '2. Какие данные собираются', body: 'При заполнении форм на сайте selesti.ru обрабатываются данные, указанные пользователем добровольно: имя, номер телефона, город.' },
                    { heading: '3. Цели обработки', body: 'Персональные данные обрабатываются для связи с пользователем по его запросу: предоставления прайса и условий сотрудничества, протоколов применения и регистрационных документов по продукции Селести.' },
                    { heading: '4. Правовое основание', body: 'Обработка осуществляется на основании согласия пользователя, предоставляемого при отправке формы на сайте, в соответствии с Федеральным законом от 27.07.2006 № 152-ФЗ «О персональных данных».' },
                    { heading: '5. Срок обработки и хранения', body: 'Данные хранятся до достижения целей обработки или до отзыва согласия пользователем, после чего удаляются.' },
                    { heading: '6. Передача третьим лицам', body: 'Оператор не передаёт персональные данные третьим лицам, за исключением случаев, предусмотренных законодательством Российской Федерации.' },
                    { heading: '7. Права пользователя', body: 'Пользователь вправе в любой момент отозвать согласие на обработку персональных данных, направив запрос на info@selesti.ru.' }
                ]
            },
            consent: {
                title: 'Согласие на обработку персональных данных',
                sections: [
                    { heading: 'Оператор', body: 'ООО «Клинрум Девелопмент», 109544, г. Москва, ул. Рабочая, д. 93, стр. 2, ОГРН 1167746375587, ИНН 7713414230, КПП 770901001, в лице генерального директора Ильина Станислава Валерьевича.\nТелефон: +7 (495) 646-01-93, e-mail: crd2016@yandex.ru.' },
                    { heading: 'Данные пользователя', body: 'Пользователь передаёт Оператору следующие персональные данные: имя, номер телефона, город.' },
                    { heading: 'Цели обработки', body: 'Данные обрабатываются для обратной связи с пользователем: направления прайса и условий сотрудничества, протоколов применения и регистрационных документов по продукции Селести.' },
                    { heading: 'Действия с данными', body: 'Согласие даётся на сбор, запись, систематизацию, накопление, хранение, уточнение, использование и уничтожение персональных данных, с использованием средств автоматизации и без них.' },
                    { heading: 'Срок действия', body: 'Согласие действует до момента достижения целей обработки либо до его отзыва пользователем.' },
                    { heading: 'Отзыв согласия', body: 'Согласие может быть отозвано в любой момент путём направления уведомления на info@selesti.ru.' }
                ]
            }
        };

        var selected = 0;
        var fading = false;

        var facet = document.getElementById('celesti-facet');
        var activeImg = document.getElementById('celesti-active-img');
        var activeFormulaEl = document.getElementById('celesti-active-formula');
        var formFormula = document.getElementById('celesti-form-formula');
        var taskRows = Array.prototype.slice.call(document.querySelectorAll('#celesti-task-list .celesti-task-row'));
        var formulaCards = Array.prototype.slice.call(document.querySelectorAll('#celesti-formulas-grid .celesti-formula-card'));

        function setFormula(value) {
            var checkAndUpdate = function() {
                var input = document.getElementById('celesti-form-formula');
                if (input) {
                    input.value = value;
                    return true;
                }
                return false;
            };

            if (!checkAndUpdate()) {
                var attempts = 0;
                var interval = setInterval(function() {
                    attempts++;
                    if (checkAndUpdate() || attempts > 10) {
                        clearInterval(interval);
                    }
                }, 100);
            }
        }

        function applySelection(i) {
            var t = tasks[i];
            taskRows.forEach(function (row, idx) {
                var active = idx === i;
                var td = tasks[idx];
                var marker = row.querySelector('.celesti-task-marker');
                var title = row.querySelector('.celesti-task-title');
                var desc = row.querySelector('.celesti-task-desc');
                row.style.borderTop = idx === 0 ? 'none' : '1px solid rgba(10,35,66,0.12)';
                row.style.borderRadius = active ? '11px 0 0 11px' : '0px';
                row.style.background = active
                    ? 'linear-gradient(90deg, ' + td.accent + '14 0%, ' + td.accent + '12 62%, ' + td.accent + '00 100%)'
                    : 'transparent';
                marker.style.width = active ? '9px' : '6px';
                marker.style.height = active ? '9px' : '6px';
                marker.style.opacity = active ? '1' : '0.45';
                title.style.fontWeight = active ? '700' : '600';
                title.style.color = active ? '#0A2342' : 'rgba(10,35,66,0.75)';
                desc.style.color = active ? '#3A4149' : '#5A6067';
            });
            formulaCards.forEach(function (card, idx) {
                var td = tasks[idx];
                card.style.backgroundColor = idx === i ? td.accent + '08' : 'transparent';
                card.style.boxShadow = idx === i ? 'inset 0 3px 0 ' + td.accent : 'none';
            });
            facet.style.backgroundImage = "url('" + t.pattern + "')";
            facet.style.backgroundSize = t.patternSize;
            facet.style.opacity = String(t.patternOpacity);
            facet.style.filter = t.patternFilter;
            activeImg.style.backgroundImage = "url('" + t.img + "')";
            activeImg.style.opacity = '1';
            activeImg.setAttribute('aria-label', t.alt);
            activeFormulaEl.textContent = t.formula;
            setFormula(t.formula);
        }

        function select(i) {
            if (i === selected || fading) return;
            fading = true;
            facet.style.opacity = '0';
            activeImg.style.opacity = '0';
            setTimeout(function () {
                selected = i;
                fading = false;
                applySelection(i);
            }, 150);
        }

        taskRows.forEach(function (row) {
            var i = parseInt(row.getAttribute('data-index'), 10);
            row.addEventListener('click', function () { select(i); });
            row.addEventListener('keydown', function (e) {
                if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); select(i); }
            });
        });

        // Smooth anchor scroll with sticky-header offset
        function scrollToId(id) {
            var el = document.getElementById(id);
            if (!el) return;
            var y = el.getBoundingClientRect().top + window.pageYOffset - 80;
            window.scrollTo({ top: y, behavior: 'smooth' });
        }

        // Form request type
        var formTitle = document.getElementById('celesti-form-title');
        var formDescription = document.getElementById('celesti-form-description');
        var formButton = document.getElementsByClassName('webform-button--submit')[0];
        var formRequest = document.getElementById('celesti-form-request');

        function setRequest(type) {
            var checkAndUpdate = function() {
                var formTitle = document.getElementById('celesti-form-title');
                if (formTitle) {
                    // все элементы есть – обновляем
                    var r = requestContent[type] || requestContent.price;
                    formTitle.textContent = r.title;
                    document.getElementById('celesti-form-description').textContent = r.description;
                    document.getElementsByClassName('webform-button--submit')[0].textContent = r.button + ' →';
                    document.getElementById('celesti-form-request').value = r.label;
                    return true;
                }
                return false; // элементы ещё не появились
            };

            if (!checkAndUpdate()) {
                // Если не нашли – пробуем ещё через 100 мс, до 10 раз
                var attempts = 0;
                var interval = setInterval(function() {
                    attempts++;
                    if (checkAndUpdate() || attempts > 10) {
                        clearInterval(interval);
                    }
                }, 100);
            }
        }

        // Burger menu
        var burger = document.getElementById('celesti-burger');
        var menu = document.getElementById('celesti-mobile-menu');
        var menuClose = document.getElementById('celesti-menu-close');
        var l1 = document.querySelector('.celesti-burger-l1');
        var l2 = document.querySelector('.celesti-burger-l2');
        var l3 = document.querySelector('.celesti-burger-l3');
        var menuOpen = false;

        function openMenu() {
            menuOpen = true;
            menu.hidden = false;
            document.body.style.overflow = 'hidden';
            burger.setAttribute('aria-expanded', 'true');
            l1.style.transform = 'translateY(7px) rotate(45deg)';
            l2.style.opacity = '0';
            l3.style.transform = 'translateY(-7px) rotate(-45deg)';
        }
        function closeMenu() {
            menuOpen = false;
            menu.hidden = true;
            document.body.style.overflow = '';
            burger.setAttribute('aria-expanded', 'false');
            l1.style.transform = 'none';
            l2.style.opacity = '1';
            l3.style.transform = 'none';
        }
        burger.addEventListener('click', function () { menuOpen ? closeMenu() : openMenu(); });
        menuClose.addEventListener('click', closeMenu);

        // Delegated nav / scroll links (also handle request type)
        document.querySelectorAll('[data-scroll]').forEach(function (a) {
            a.addEventListener('click', function (e) {
                e.preventDefault();
                var req = a.getAttribute('data-request');
                if (req) setRequest(req);
                if (menuOpen) closeMenu();
                var target = a.getAttribute('data-scroll');
                setTimeout(function () { scrollToId(target); }, 0);
            });
        });

        // Go to selected formula
        document.getElementById('celesti-goto-formula').addEventListener('click', function (e) {
            e.preventDefault();
            scrollToId('formula-' + selected);
        });

        // Legal modals
        var legal = document.getElementById('celesti-legal');
        var legalDialog = document.getElementById('celesti-legal-dialog');
        var legalTitle = document.getElementById('celesti-legal-title');
        var legalBody = document.getElementById('celesti-legal-body');
        var legalClose = document.getElementById('celesti-legal-close');
        var legalOpen = false;

        function openLegal(kind) {
            var c = legalContent[kind];
            if (!c) return;
            legalTitle.textContent = c.title;
            legalBody.innerHTML = '';
            c.sections.forEach(function (sec) {
                var wrap = document.createElement('div');
                var h = document.createElement('div');
                h.style.cssText = 'font-size:17px;font-weight:700;color:rgb(10,35,66);margin-bottom:8px;';
                h.textContent = sec.heading;
                var b = document.createElement('div');
                b.style.whiteSpace = 'pre-line';
                b.textContent = sec.body;
                wrap.appendChild(h);
                wrap.appendChild(b);
                legalBody.appendChild(wrap);
            });
            legal.hidden = false;
            legalOpen = true;
        }
        function closeLegal() { legal.hidden = true; legalOpen = false; }

        /*    document.querySelectorAll('[data-legal]').forEach(function (a) {
                a.addEventListener('click', function (e) {
                    e.preventDefault();
                    openLegal(a.getAttribute('data-legal'));
                });
            });*/
        document.addEventListener('click', function(e) {
            var legalLink = e.target.closest('[data-legal]');
            if (legalLink) {
                e.preventDefault();
                openLegal(legalLink.getAttribute('data-legal'));
            }
        });
        legalClose.addEventListener('click', closeLegal);
        legal.addEventListener('click', function (e) { if (e.target === legal) closeLegal(); });

        // Cookie banner
        var cookie = document.getElementById('celesti-cookie');
        var cookieAccept = document.getElementById('celesti-cookie-accept');
        var accepted = true;
        try { accepted = localStorage.getItem('celesti_cookies_accepted') === '1'; } catch (e) {}
        if (!accepted) cookie.hidden = false;
        cookieAccept.addEventListener('click', function () {
            try { localStorage.setItem('celesti_cookies_accepted', '1'); } catch (e) {}
            cookie.hidden = true;
        });

        // Escape closes menu / modal
        document.addEventListener('keydown', function (e) {
            if (e.key !== 'Escape') return;
            if (menuOpen) closeMenu();
            if (legalOpen) closeLegal();
        });

        setFormula(tasks[selected].formula);
    })();
});

(function($) {

    /*    // cookie popup
        const container = document.querySelector(".warning");
        if (document.cookie.indexOf("warning") != -1) {
            container.classList.remove("warning--active");
            container.classList.add("warning--hide");
        }
        if (document.querySelector(".warning")) {
            const apply = container.querySelector(".warning__apply");
            apply.addEventListener("click", () => {
                container.classList.remove("warning--active");
                container.classList.add("warning--hide");
                document.cookie = "warning=true; max-age=2592000; path=/";
            });
        };*/

    $(document).ready(function() {
        // forms fancy
        $('.fancy-form').fancybox();
    });

})(jQuery);